import { IsBoolean, IsEnum, IsInt, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';
import { BaseDto } from './base.dto';
import { AIBSourceApplication } from '../enum/payment-aib';

/**
 * Data Transfer Object for creating a new BankAibMid configuration.
 * Used to validate incoming request bodies for creation endpoints.
 */
export class BankAibMIDDto extends BaseDto {
  @IsInt()
  @IsNotEmpty()
  merchantId: number;

  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  storeId: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  connectSharedSecret: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  restApiKey: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  restApiSecret: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(3)
  currency: string;

  @IsEnum(AIBSourceApplication)
  @IsNotEmpty()
  source: AIBSourceApplication;

  @IsOptional()
  @IsBoolean()
  enableExtendedResponseHash?: boolean;
}

